import React, { useCallback, useEffect, useRef, useState } from "react";
import Modal from "react-modal";

import TripEventsApi from "../../../../services/resources/TripEventsApi";
import { notify } from "react-notify-toast";
import axios from "axios";

function AssignedVenueModal({
  onClose,
  campusName,
  chabadHouseName,
  currentAssignedVenueId,
  enrollmentId,
  preferredVenueName,
  shliachFirstName,
  shliachLastName,
  shluchaFirstName,
  shluchaLastName,
  venues,
}) {
  const [assignedVenueId, setAssignedVenueId] = useState(
    currentAssignedVenueId ? currentAssignedVenueId.toString() : "",
  );
  const [submitting, setSubmitting] = useState(false);

  const apiSignalRef = useRef(axios.CancelToken.source());

  useEffect(() => {
    const _apiSignal = apiSignalRef.current;
    return () => _apiSignal.cancel();
  }, []);

  const onSubmit = useCallback(async () => {
    setSubmitting(true);

    try {
      await TripEventsApi.updateEnrollmentsAssignedVenue(
        apiSignalRef.current.token,
        [enrollmentId],
        assignedVenueId ? parseInt(assignedVenueId) : null,
      );

      onClose(true);
      notify.show("Venue updated", "success");
    } catch (err) {
      if (!axios.isCancel(err)) {
        notify.show("Error updating venue", "error");
      }
    }

    setSubmitting(false);
  }, [assignedVenueId, enrollmentId, onClose]);

  return (
    <Modal isOpen={true} className="modal-container">
      <div className="modal-card card medium-modal">
        <p className="large-text fw-500 mb-8">Assign Venue</p>
        <div className="mb-16">
          <div className="fw-700">
            {shliachLastName ? `${shliachFirstName} ${shliachLastName}` : ""}
            {shluchaLastName
              ? `${shliachLastName ? " and " : ""}${shluchaFirstName} ${shluchaLastName}`
              : ""}
          </div>
          <div className="fw-500 small-text">
            {chabadHouseName ? `${chabadHouseName} | ` : ""}
            {campusName}
          </div>
        </div>
        <div className="flex flex-align-center mb-8">
          <div className="input-label">Venue</div>
          <select
            className="custom-input ml-8"
            name="assignedVenueId"
            onChange={(e) => setAssignedVenueId(e.target.value)}
            value={assignedVenueId}
          >
            <option value="">No venue</option>
            {venues
              .filter((v) => !v.hideFromShluchim)
              .map((venue) => (
                <option key={venue.id} value={venue.id.toString()}>
                  {venue.name}
                </option>
              ))}
          </select>
        </div>
        {preferredVenueName && (
          <p className="small-text accent-text mb-16">
            {preferredVenueName} is preferred
          </p>
        )}
        <div className="flex flex-justify-end mt-24">
          <button
            className="custom-btn btn btn-light uppercase-text mr-16"
            disabled={submitting}
            onClick={() => onClose(false)}
          >
            Cancel
          </button>
          <button
            className="custom-btn btn btn-accent uppercase-text"
            disabled={submitting}
            onClick={onSubmit}
          >
            {submitting ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default AssignedVenueModal;
